import React, { useEffect, useState } from "react";

import axios from "axios";

const SowReportDialog = ({
  open,
  createdSowId,
  sowSecondPrintRef,
  sowPrintReportRef,
}) => {
  const [reportData, setReportData] = useState();

  const serverURL = process.env.REACT_APP_URL;

  const getSowReportData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/requestForProposal/viewSowReport/${createdSowId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReportData(response.data.data);
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  useEffect(() => {
    getSowReportData();
  }, [open]);
  const keyLabels = {
    // colorCode: "Color Code",
    // colorCodeDetails: "Color Code Details",
    layer: "Layer",
    passes: "Passes",
    printDPI: "Print DPI",
    printOnSides: "Print On Sides",
  };
  const keyPrintingLabels = {
    applicationPlace: "Application Place",
    artWork: "Artwork",
    installationfloor: "Installation Floor",
    installationwall: "Installation Wall",
    outerSize: "Outer Size",
    printMaterialgrade: "Print Material Grade",
    printMaterialsubstrate: "Print Material Substrate",
  };

  const excludedFields = [
    "productType",
    "printMaterialbrand",
    "printGSM",
    "installationtableTop",
    "installationprojected",
    "installationceiling",
    "installation",
    "brand",
  ];

  const keyMachineLabels = {
    machinePrintingSubType: "Type Of Printer Head",
    picoliter: "Picoliter",
    machineBrand: "Brand",
    maxPrintSize: "Machine Width",
    ageOfMachine: "Machine Age",
  };

  return (
    <>
      {open && (
        <div>
          <h2 className="text-lg text-[var(--primary-color)] font-bold mt-3">
            Printing Report :-
          </h2>

          <div
            className="p-6 border border-black-900 rounded-md"
            ref={sowPrintReportRef}
          >
            <div className="flex justify-between items-center mb-4">
              <div className="flex justify-center items-center">
                <div>
                  <img
                    // src="/assests/AdminDashboard/pixellSowReportLogo.png"
                    src="/assests/images/pixell dark.png"
                    width={80}
                    height={80}
                    alt="logo"
                  />
                </div>
                <div className="mx-4">
                  {/* <h2 className="text-4xl font-bold">Pixell</h2> */}
                  <p className="text-sm text-gray-500">
                    Campaign Id: #{reportData?.campaignId?.slice(-6)}
                  </p>
                  <p className="text-sm text-gray-500">support@pixell.in</p>
                </div>
              </div>
              <div className="text-start">
                <h2 className="text-3xl text-black font-semibold">
                  Scope Of Work
                </h2>
              </div>
            </div>
            <div className=" flex justify-between border-t border-b border-black pt-4 pb-4">
              <div className="border-l border-black px-4">
                <h3 className="text-lg font-semibold">Product:</h3>
                <p>
                  <span className="text-sm font-light">Product Category:</span>{" "}
                  {reportData?.productDetails?.productType}
                </p>
                <p>
                  <span className="text-sm font-light">Service:</span> Printing
                </p>
                <p>
                  <span className="text-sm font-light">Weight:</span>{" "}
                  {reportData?.materialDetailsForFabrication
                    ?.frameDetailweight || "0kg"}
                </p>
              </div>
              <div className="flex">
                <div className="mx-6">
                  <img
                    src={
                      reportData?.productDetails?.printImage ||
                      "/assests/AdminDashboard/userForIP.webp"
                    }
                    className="w-64 h-32"
                    alt="logo"
                  />
                </div>
                <div className="mx-6">
                  <img
                    src={
                      reportData?.productDetails?.productSecondImg ||
                      "/assests/AdminDashboard/userForIP.webp"
                    }
                    className="w-64 h-32"
                    alt="logo"
                  />
                </div>
              </div>
            </div>

            <div className=" w-full mt-5">
              <h3 className="text-xl font-semibold mb-3">Description</h3>
              <p className="border rounded-md p-3 text-[14px] break-words">
                {reportData?.description
                  ?.split("•")
                  .filter((line) => line.trim() !== "")
                  .map((line, idx) => (
                    <p key={idx}>
                      {idx + 1}. {line.trim()}
                    </p>
                  ))}
              </p>
            </div>
            <div className="flex justify-center gap-3 py-2">
              <div className="w-[50%] ">
                <h3 className="text-xl font-semibold">Printing Specs</h3>

                <table className=" w-full border-collapse mt-4 border text-sm">
                  <thead>
                    <tr className="bg-black text-white">
                      <th className="border text-start p-2">S. No.</th>
                      <th className="border text-start p-2">Heading</th>
                      <th className="border text-start p-2">Specifications</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData?.materialDetailsForPrinting &&
                      Object.entries(reportData.materialDetailsForPrinting)
                        .filter(([key, value]) => !excludedFields.includes(key)) // Remove empty and unwanted fields
                        .map(([key, value], i) => (
                          <tr
                            key={i}
                            className={i % 2 !== 0 ? "bg-gray-100" : ""}
                          >
                            <td className="border p-2">{i + 1}</td>
                            <td className="border p-2">
                              {keyPrintingLabels[key] || key}
                            </td>
                            <td className="border p-2">{value || "N/A"}</td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
              <div className="w-[50%]">
                <h3 className="text-xl font-semibold">Printing Parameters</h3>
                <table className="w-full border-collapse mt-4 border  text-sm">
                  <thead>
                    <tr className="bg-black text-white">
                      <th className="border text-start p-2">S. No.</th>
                      <th className="border text-start p-2">Heading</th>
                      <th className="border text-start p-2">Specifications</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData?.printingParametersForPrinting &&
                      Object.entries(
                        reportData.printingParametersForPrinting
                      ).map(([key, value], i) => (
                        <tr
                          key={i}
                          className={i % 2 !== 0 ? "bg-gray-100" : ""}
                        >
                          <td className="border p-2">{i + 1}</td>
                          <td className="border p-2">
                            {keyLabels[key] || key}
                          </td>
                          <td className="border p-2">{value || "N/A"}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div className=" w-full mt-5">
              <h3 className="text-xl font-semibold mb-3">Paint</h3>
              <p className="border rounded-md p-3 text-[14px]">
                {reportData?.paint || "No Data Available"}
              </p>
            </div> */}
            <div>
              <h3 className="text-xl font-semibold my-3">Approved Brands</h3>

              <table className="w-full border-collapse mt-4 border text-sm">
                <thead>
                  <tr className="bg-black text-white">
                    <th className="border text-start p-2">S. No.</th>
                    <th className="border text-start p-2">PRODUCT</th>
                    <th className="border text-start p-2">APPROVED BRAND</th>
                    <th className="border text-start p-2">MODEL NO.</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(6)].map((_, i) => (
                    <tr key={i} className={i % 2 !== 0 ? "bg-gray-100" : ""}>
                      <td className="border p-2 ">{i + 1}</td>
                      <td className="border p-2">
                        {
                          [
                            "Backlight Vinyl",
                            "Sanfa Fabric",
                            "PVC Banner Media",
                            "Shelf Adhesive Wallpaper",
                            "Color Vinyl",
                            "Reflective Vinyl",
                          ][i % 6]
                        }
                      </td>
                      <td className="border p-2">
                        {
                          ["3M", "Avery", "NovaSign", "Avery", "LG", "3M"][
                            i % 6
                          ]
                        }
                      </td>
                      <td className="border p-2">
                        {
                          [
                            "Series-1080",
                            "110-300 GSM",
                            "SRB32711",
                            "STD.722",
                            "LC.2000",
                            "Series-400",
                          ][i % 6]
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <div className="mt-6">
              <h3 className="text-lg font-semibold ">
                Printing Machines Required
              </h3>
              <div className="grid grid-cols-2 gap-4 mt-2">
                {[...Array(2)].map((_, i) => (
                  <div key={i} className="border rounded-lg shadow-md bg-white">
                    <h4 className="font-semibold text-lg border-b pb-2 mb-2 bg-black p-4 text-white">
                      Welding Machine
                    </h4>
                    <div className="grid grid-cols-3 gap-4 p-4">
                      <div>
                        <p className="text-sm text-black font-semibold">
                          Sub Category
                        </p>
                        <p className="text-sm text-gray-500">Cat Name</p>
                      </div>
                      <div>
                        <p className="text-sm text-black font-semibold">
                          Ampere Of Machine
                        </p>
                        <p className="text-sm text-gray-500">30 A</p>
                      </div>
                      <div>
                        <p className="text-sm text-black font-semibold">
                          Controller Setting
                        </p>
                        <p className="text-sm text-gray-500">Setting</p>
                      </div>
                      <div>
                        <p className="text-sm text-black font-semibold">
                          Age Of Machine
                        </p>
                        <p className="text-sm text-gray-500">4 Years</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
          <div
            className="p-6 border border-black-900 rounded-md"
            ref={sowSecondPrintRef}
          >
            <div className="mt-6">
              <h3 className="text-xl font-semibold my-3">
                Printing Machines Required
              </h3>
              <div className="grid grid-cols-2 gap-4 mt-2">
                {reportData?.machinesNeededForPrinting?.length === 0 ? (
                  <p className="border rounded-md p-3 text-[14px]">
                    No Machine Required
                  </p>
                ) : (
                  reportData?.machinesNeededForPrinting.map((s, i) => (
                    <div
                      key={i}
                      className="border shadow-md bg-white rounded-t-md"
                    >
                      <h4 className="font-semibold text-lg border-b  py-1  bg-black px-4 text-white rounded-t-md">
                        {s.type || "N/A"}
                      </h4>
                      <table className="w-full border-collapse  border  text-sm">
                        <tbody>
                          {Object.entries(s.details).map(([key, value], i) => (
                            <tr
                              key={i}
                              className={i % 2 != 0 ? "bg-gray-100" : ""}
                            >
                              <td className="border p-2 ">{i + 1}</td>
                              <td className="border p-2">
                                {keyMachineLabels[key]}
                              </td>
                              <td className="border p-2">{value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))
                )}
              </div>
            </div>

            <section className="p-2">
              <h3 className="text-xl font-semibold my-3">
                Printing Guidelines
              </h3>
              <div className="w-full p-2 border rounded-md">
                {reportData?.printingGuidelines
                  ?.split("•")
                  .filter((line) => line.trim() !== "")
                  .map((line, idx) => (
                    <p key={idx}>
                      {idx + 1}. {line.trim()}
                    </p>
                  ))}
              </div>
            </section>
            <section className="p-2">
              <h3 className="text-xl font-semibold my-3">PDI Guidelines</h3>
              <div className="w-full p-2 border rounded-md">
                {reportData?.pdiGuidelines
                  ?.split("•")
                  .filter((line) => line.trim() !== "")
                  .map((line, idx) => (
                    <p key={idx}>
                      {idx + 1}. {line.trim()}
                    </p>
                  ))}
              </div>
            </section>
            <section className="p-2">
              <h3 className="text-xl font-semibold my-3">
                Packaging Guidelines
              </h3>
              <div className="w-full p-2 border rounded-md">
                {reportData?.packagingGuidelines
                  ?.split("•")
                  .filter((line) => line.trim() !== "")
                  .map((line, idx) => (
                    <p key={idx}>
                      {idx + 1}. {line.trim()}
                    </p>
                  ))}
              </div>
              <section className="p-2">
                <h3 className="text-xl font-semibold my-3">
                  Delivery Guidelines
                </h3>
                <div className="w-full p-2 border rounded-md">
                  {reportData?.deliveryGuidelines
                    ?.split("•")
                    .filter((line) => line.trim() !== "")
                    .map((line, idx) => (
                      <p key={idx}>
                        {idx + 1}. {line.trim()}
                      </p>
                    ))}{" "}
                </div>
              </section>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default SowReportDialog;
